import React, { useState } from 'react';
import { classIf, getConfiguration } from '../../../../data/utils';
import { getLabel } from '../../../../data/labels';
import InEvidenzaCompetitionItem from './InEvidenzaCompetitionItem';
import InEvidenzaSportItem from './InEvidenzaSportItem';

export default function InEvidenzaSection(props) {
    const conf = getConfiguration();
    const [startCollapsed] = useState(() => {
        try {
            const conf = getConfiguration();
            return conf.iess === 'COLLAPSED' || conf.pls === 'LANDING_3';
        } catch (e) {
            return false;
        }
    });
    return (
   !conf.iwh && 
        <div id="accordionLaterale" className="contenitore-competizioni-sport" role="tablist" aria-multiselectable="true">
            <div className="card elemento-competizioni-widget">
                <div className={"titolo-accordion maiuscolo bianco d-flex d-centro-v pointer toggle-nascondi-live tog-menu" + classIf(startCollapsed, 'collapsed')} data-toggle="collapse" data-parent="#accordionLaterale" href="#filtro-in-evidenza-content">
                    <a href-disabled="#!" role="button" tabIndex="0" className=" pointer d-flex d-centro-v maiuscolo grassetto">
                        {getLabel('menu_prematch.in_evidenza')}
                    </a>
                    <span>{props.data.tournamentsCount}</span>
                </div>
                <div id="filtro-in-evidenza-content" className={"competzioni-sub collapse in margine-su-mezzo" + (startCollapsed ? '' : ' show')} role="tabpanel" aria-labelledby="filtro-in-evidenza">
                    {conf.iess === 'NO_SPORT' ?
                        props.data.tournamentsList.map(t =>
                            <InEvidenzaCompetitionItem key={t.id} {...t} />
                        )
                        :
                        props.data.sportsList.map(s =>
                            <InEvidenzaSportItem key={s.id} {...s} startCollapsed={startCollapsed} />
                        )
                    }
                </div>
            </div>
        </div>

    );
}
